import { useReducer } from "react";
import { dropdownReducer, initialDropdown } from "../reducers/dropdown.reducer";

const useDropdown = () => {
  const [data, dispatcher] = useReducer(dropdownReducer, initialDropdown);
  return [data, dispatcher];
};

export default useDropdown;
